import { Step } from 'react-joyride';

export interface TourStepConfig extends Step {
  route: string;
  stepNumber: number;
}

export const tourSteps: TourStepConfig[] = [
  // Dashboard Page - Steps 1-4
  {
    target: '[data-tour-id="dashboard-header"]',
    content: 'Welcome to OnSite! This is your personal dashboard where you can track your interview performance and progress.',
    title: 'Your Dashboard',
    route: '/dashboard',
    stepNumber: 1,
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour-id="performance-stats"]',
    content: 'Track your interview performance metrics including completion rate, average scores, and improvement trends.',
    title: 'Performance Metrics',
    route: '/dashboard',
    stepNumber: 2,
    placement: 'bottom',
  },
  {
    target: '[data-tour-id="quick-actions"]',
    content: 'Quick access to start new interviews, view your history, and manage your profile settings.',
    title: 'Quick Actions',
    route: '/dashboard',
    stepNumber: 3,
    placement: 'top',
  },
  {
    target: '[data-tour-id="job-recommendations"]',
    content: 'Based on your skills and performance, we recommend job opportunities that match your profile.',
    title: 'Job Recommendations',
    route: '/dashboard',
    stepNumber: 4,
    placement: 'top',
  },

  // Interview Selection Page - Step 5
  {
    target: '[data-tour-id="interview-types"]',
    content: 'Choose from various interview types including coding challenges, analytical scenarios, and role-specific questions.',
    title: 'Interview Selection',
    route: '/interviews',
    stepNumber: 5,
    placement: 'bottom',
  },

  // Interview Panel - Steps 6-7
  {
    target: '[data-tour-id="interview-mode-selector"]',
    content: 'Select between Practice mode (no time pressure) or Evaluation mode (realistic interview conditions).',
    title: 'Interview Modes',
    route: '/interview/analytical',
    stepNumber: 6,
    placement: 'bottom',
  },
  {
    target: '[data-tour-id="start-interview-button"]',
    content: 'Once you have selected your preferences, click here to begin your interview. You can access hints and tips during practice mode.',
    title: 'Start Your Interview',
    route: '/interview/analytical',
    stepNumber: 7,
    placement: 'top',
  },

  // Role Prep - Step 8
  {
    target: '[data-tour-id="role-prep-list"]',
    content: 'Prepare for specific roles with curated resources, common questions, and industry insights.',
    title: 'Role Preparation',
    route: '/role-prep',
    stepNumber: 8,
    placement: 'bottom',
  },

  // Interview History - Step 9
  {
    target: '[data-tour-id="interview-history"]',
    content: 'Review all your past interviews, see detailed feedback, and track your improvement over time.',
    title: 'Interview History',
    route: '/interview-history',
    stepNumber: 9,
    placement: 'bottom',
  },

  // Get Started - Step 10 (Final)
  {
    target: '[data-tour-id="get-started-actions"]',
    content: 'You are all set! Choose an action to begin your interview preparation journey. Good luck!',
    title: 'Ready to Start!',
    route: '/get-started',
    stepNumber: 10,
    placement: 'top',
  },
];

export const TOTAL_TOUR_STEPS = tourSteps.length;
